import { getMessages } from '../../../../../store/constants';

export const CLASS_COMMENTS_SECTION = 'comments-section';
export const CLASS_COMMENTS_SECTION_TITLE = CLASS_COMMENTS_SECTION + '__title';

export const CARD_SECTION_COMMENTS = getMessages().getText('card_form_section_comments');
export const CARD_SECTION_COMMENTS_ADD_ATTACHMENT = getMessages().getText('card_form_comment_add_attachment');

export const KEY_UP = 'ArrowUp';
export const KEY_DOWN = 'ArrowDown';
export const KEY_ENTER = 'Enter';
